import { Grid } from '@material-ui/core'
import React, {useState, useEffect} from 'react'
import { ColorPicker } from 'material-ui-color';
import ContainedButton from '../../../../../../components/Actions/ContainedButton'
import InputForm from '../../../../../../components/Forms/InputForm'
import SimpleModal from '../../../../../../components/Overlays/SimpleModal'
import DisplayText from '../../../../../../components/Texts/DisplayText'
import ImageContainer from '../components/ImageContainer'
import ChangeImageModal from './ChangeImageModal'
import { isFormValid, onGetErrorMessage, onGetFormData, onInitEmptyForm, onInitForm, onSetErrorsToForm } from '../../../../../../shared/utility'
import { request_brand, request_update_brand } from '../requests'
import { translations as translations_esp } from '../../../../../../texts/esp/brands-translations'

const EditBrandModal = ({open, onClose, onUpdateCompleted, id}) => {

    const content = translations_esp

    //general
    const [form, setForm] = useState(JSON.parse(JSON.stringify(formData)))
    const [color, setColor] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [img, setImg] = useState(null)
    const [disabled, setDisabled] = useState(false)

    //modals
    const [image_modal, setImageModal] = useState(false)

    useEffect(() => {
    const initModule = async() => {
        if(!open){
            let _form = onInitEmptyForm(form, content.modal.form)
            setForm(_form)
            setError(''); setLoading(false);
            setDisabled(false)
        }
        if(open){
            const _brand = await request_brand(id)
            setImg(_brand.brand_data.image_web)
            setColor(_brand.brand_data.color)
            let _form = onInitForm(form, _brand.brand_data) 
            setForm(_form)
        }
    }
    initModule()
    }, [open])


    const onChange = (data) => {
        let temp = { ...form }
        const id = data.config.id
        temp[id] = { ...data }
        setForm(temp)
    }

    const onSubmit = async () => {
       const errors = isFormValid(form)
        /// Check if the form is valid
        if(errors && errors.length){
            const new_form = onSetErrorsToForm(form, errors)
            setForm(new_form)
            console.log('hay errores')
            return
        } 

        //Extract data
        let data2send = onGetFormData(form)
        data2send.color = color 
        //console.log(data2send)
        
        setLoading(true)
        setDisabled(true)
        try {
            await request_update_brand(id, data2send);
            setLoading(false)
            onUpdateCompleted()
        } catch (error) {
            console.log(error)
            setError(onGetErrorMessage(error))
            setLoading(false)
        }
        setDisabled(false)

    }

    const onChangeColor = (data) =>{
        if(data && data.css){
            setColor(data.css.backgroundColor)
        }else{
            setColor(data)
        }    
        //console.log(data)
    }

  
    return (
        <SimpleModal open={open} onClose={onClose}>
            <ChangeImageModal id={id} open={image_modal} onClose={() => setImageModal(false)} onUpdateCompleted ={onUpdateCompleted}/>
            <DisplayText variant='h5' color='primary' style={{ fontWeight: 500 }}>{content.modal.edit_title}</DisplayText>
                {/* <DisplayText >Por favor ingresa los datos solicitados</DisplayText> */}
                <div style={{padding:'30px 0px 24px'}}>
                    <Grid container justify='center' spacing={2}>
                        <Grid item xs={12} >
                            <ImageContainer image={img} onClick={()=>setImageModal(true)} />
                        </Grid>
                        <Grid item xs={12} >
                            <InputForm data={form.name} onChange={onChange} />
                        </Grid>
                        <Grid item xs={12}>
                            <DisplayText variant='body2' color='textSecondary'>{content.modal.form.color.label}</DisplayText>
                            <ColorPicker value={color} disableAlpha onChange={onChangeColor} 
                                 disablePlainColor/>
                        </Grid>
                        <Grid item xs={12} >
                            <InputForm data={form.description} onChange={onChange} />
                        </Grid>
                        <Grid item xs={12} >
                            <InputForm data={form.url} onChange={onChange} />
                        </Grid> 
                    </Grid>
                </div>
                <ContainedButton color='primary' fullWidth onClick={onSubmit} loading={loading} disabled={disabled}>
                    {content.modal.button}
                </ContainedButton>
                <DisplayText color='error' align='center'>{error}</DisplayText>
        </SimpleModal>
    )

}


export default EditBrandModal


const formData = {
    name: {
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'name',
            type: 'text',
            fullWidth: true,
            label: 'Nombre',
            helperText: 'Este campo debe tener al menos 1 caracter y máximo 255'
        },
        rules: {
            type: 'distance',
            min: 1, max: 255
        }
    },
    description: {
        value: '',
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: false,
        config: {
            id: 'description',
            type: 'text',
            fullWidth: true,
            label: 'Descripción',
            helperText: 'Este campo debe tener al menos 1 caracter y máximo 255',
            multiline:true,
            rows:3
        },
        rules: {
            type: 'distance',
            min: 1, max: 255
        }
    },
    url: {
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'url',
            type: 'text',
            fullWidth: true,
            label: 'Url',
            helperText: 'Este campo debe tener al menos 1 caracter y máximo 255'
        },
        rules: {
            type: 'distance',
            min: 1, max: 500
        }
    },
    /* color: {
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'color',
            type: 'text',
            fullWidth: true,
            label: 'Color',
            helperText: 'Este campo debe tener al menos 1 caracter y máximo 255'
        },
        rules: {
            type: 'distance',
            min: 1, max: 255
        }
    }, */
}